import React from 'react';
const SCMessageBarContext = React.createContext<any>({
    setIsActive: () => {},
    setMessageBarType: () => {},
    setMessage: () => {},
});
export default SCMessageBarContext;
